module.exports = __webpack_public_path__ + "img/training_system_m.c830f143.jpg";